<template>
  <div class="language-switcher__region accordion">
    <h3 :class="classObject()" ref="button" @click="toggleAccordion()" v-if="lang.title">
      <span class="name">{{ lang.title }}</span>
      <span class="icon" v-if="window.width < 768">
        <caret-lang-svg />
      </span>
    </h3>
    <div
      class="language-switcher__content accordion__content"
      :style="{ height: contentHeight }"
    >
      <ul class="language-switcher__languages accordion__wrapper" ref="content">
        <language-list-item
          v-for="item in lang.items"
          :key="item.id"
          :item="item"
          :continent="lang.slug"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import CaretLangSvg from '../../../../../assets/img/icons/caret-lang.svg';
import languageListItem from './languageListItem.vue';
import { mixin } from '../../mixin';

export default {
  name: 'languageList',
  mixins: [mixin],
  components: {
    languageListItem,
    CaretLangSvg,
  },
  props: {
    lang: Object,
  },
  data() {
    return {
      isActive: false,
      contentHeight: 0,
    };
  },
  created() {
    if (window) {
      this.handleResize();
      this.setHeight();
      this.setMinTitlesHeight();

      window.addEventListener('resize', () => {
        this.handleResize();
        this.setHeight();
        this.setMinTitlesHeight();
      });
    }
  },
  destroyed() {
    if (window) {
      window.removeEventListener('resize', () => {
        this.handleResize();
        this.setHeight();
        this.setMinTitlesHeight();
      });
    }
  },
  methods: {
    setHeight() {
      if (this.window.width >= 768) {
        this.contentHeight = 'auto';
      }
    },
    setMinTitlesHeight() {
      if (this.window.width >= 768) {
        let max = 0;
        const titles = [...document.querySelectorAll('.accordion__trigger')];
        titles.forEach(title => {
          if (title.scrollHeight > max) max = title.scrollHeight;
          title.style.minHeight = `${max}px`
        });
      }
    },
    classObject() {
      return {
        'language-switcher__region-title accordion__trigger': true,
        'is-active': this.isActive,
      };
    },
    toggleAccordion() {
      if (this.window.width < 768) {
        this.isActive = !this.isActive;
        if (this.isActive) {
          const height = this.$refs.content.clientHeight;
          this.contentHeight = `${height}px`;
        } else {
          this.contentHeight = 0;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.language-switcher {
  &__region {
    @include up-tablet {
      min-width: 0;
    }

    //&:nth-child(1) {
    //  @include up-tablet {
    //    grid-column: 1/2;
    //    grid-row: 1/2;
    //  }
    //
    //  @include up-desktop {
    //    grid-column: 1/2;
    //    grid-row: 1/2;
    //  }
    //}
    //
    //&:nth-child(2) {
    //  @include up-tablet {
    //    grid-column: 1/2;
    //    grid-row: 2/3;
    //  }
    //
    //  @include up-desktop {
    //    grid-column: 2/3;
    //    grid-row: 1/2;
    //  }
    //}
    //
    //&:nth-child(3) {
    //  @include up-tablet {
    //    grid-column: 2/3;
    //    grid-row: 2/3;
    //  }
    //
    //  @include up-desktop {
    //    grid-column: 3/4;
    //    grid-row: 1/2;
    //  }
    //}
    //
    //&:nth-child(4) {
    //  @include up-tablet {
    //    grid-column: 2/3;
    //    grid-row: 1/2;
    //  }
    //
    //  @include up-desktop {
    //    grid-column: 4/5;
    //    grid-row: 1/2;
    //  }
    //}
  }
}

.accordion {
  margin-bottom: 50px;

  @include up-tablet {
    margin-bottom: 0;
  }

  &__trigger {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: $f-neutraBook;
    font-size: 24px;
    line-height: 1.5;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    text-align: center;

    @include up-laptop {
      min-height: 3em;
    }

    &.is-active {
      .icon {
        transform: translateY(-2px) rotate(0deg);
      }
    }

    .icon {
      margin-left: 8.5px;
      display: flex;
      transform: rotate(180deg);
      @include anim(transform);
    }
  }

  &__content {
    overflow: hidden;
    @include anim(height);
  }

  &__wrapper {
    margin: auto;
    width: fit-content;
    display: flex;
    flex-direction: column;
  }
}
</style>
